import React, { useLayoutEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonLeftText from 'components/atoms/Button/Button.leftText';
import ButtonRightText from 'components/atoms/Button/Button.rightText';
import { isACtiveSatisfyModal, disableAllMenu, isActiveSideMenu, isActiveConversationGuideModal, isActiveServiceGuideModal } from 'modules/actions/statusMenu';
import PropTypes from 'prop-types';
import { chatList } from 'modules/actions/chat';


const SideMenu = ({ styleDef }) => {
  const sideStyle = styleDef;
  const sideMenuStatus = useSelector(state => state.isActive.sideMenu);
  const chatListLength = useSelector(state => state.chatList.data.length);

  const settingMenuStatus = useSelector(state => state.isActive.settingMenu);
  const quickMenuStatus = useSelector(state => state.isActive.quickMenu);
  const expandImageModalStatus = useSelector(state => state.isActive.expandImageModal);
  const buttonRef = useRef(null);
  // sideMenufocusRef.current.focus();
  useLayoutEffect(() => {
    if (buttonRef.current !== null) buttonRef.current.focus();
  })
  const dispatch = useDispatch();
  const onSatisfyModal = () => {
    if (sideMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    dispatch(isACtiveSatisfyModal());
  };
  const onConversationGuide = () => {
    if (sideMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    dispatch(isActiveConversationGuideModal());
  };
  const onServiceGuide = () => {
    if (sideMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    dispatch(isActiveServiceGuideModal());
  };

  /* 사이드메뉴 클릭시 다른 메뉴창 닫힘 */
  const onSideMenu = () => {
    if (settingMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    if (quickMenuStatus) {
      dispatch(isActiveQuickMenu());
    }
    if (expandImageModalStatus) {
      dispatch(isActiveExpandImageModal());
    }
    dispatch(isActiveSideMenu());
  };

  const execOnSendMsg = text => {
    const paramSet = {
      inType: 'query',
      inStr: text,
      inLabel: text
    };
    dispatch(chatList(paramSet));
    dispatch(disableAllMenu());
    // dispatch(useRequestDM(text, 'query'));
  };

  return (
    <div className="menu_bar" style={styleDef} ref={buttonRef}>
      <ButtonLeftText
        label="이용 안내"
        value="이용 안내"
        labelIcon="ri-door-lock-line"
        viewStatus=""
        styleDef={{}}
        onClickEvt={() => onServiceGuide()}
        error={null}
      />
      <ButtonLeftText
        label="대화 가이드"
        value="대화 가이드"
        labelIcon="ri-questionnaire-line"
        viewStatus=""
        styleDef={{}}
        onClickEvt={() => onConversationGuide("대화 가이드")}
        error={null}
      />
      <ButtonLeftText
        label="서비스 만족도 평가"
        value="서비스 만족도 평가"
        labelIcon="ri-thumb-up-line"
        viewStatus=""
        styleDef={{}}
        onClickEvt={() => onSatisfyModal()}
        error={null}
      />
      <div className="_btn_left_txt_div" style={{ "justifyContent": "center" }} onClick={() => onSideMenu()}>
        <button type="button" className="_btn_div" title="퀵메뉴 닫기" >
          <div className="_txt">닫기</div>
          <div className="_icon">
            <i className="ri-close-line-2" style={{ "display": "inline-block", "height": "22px" }}>
              <div style={{ "display": "none" }}>icon</div>
            </i>
          </div>
        </button>
      </div>
    </div>
  );
};

SideMenu.propTypes = {
  styleDef: PropTypes.object
};
SideMenu.defaultProps = {
  styleDef: {}
};
export default SideMenu;
